import React, { useState } from "react";
import logoImage from "../assets/logoHeader.png";
import logo from "../assets/logo.png";
import logoNavMobile from "../assets/logoNavMobile.png";

const Header = () => {
  // Sử dụng state để theo dõi việc mở/đóng menu
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Hàm toggle menu
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div className="h-[70px] sm:h-[100px]">
      <nav className="bg-[#2B8DFE] text-white fixed w-full z-20 top-0 left-0 dark:border-gray-600 h-[100px] md:block hidden">
        <div className="max-w-screen-xl flex items-center justify-between mx-auto p-4 h-full">
          <a
            href="https://www.rr88bet.com/"
            className="flex items-center space-x-3 rtl:space-x-reverse"
          >
            <img src={logoImage} alt="RR88 Logo" />
          </a>
          <div className="flex md:order-2 space-x-3 md:space-x-0 rtl:space-x-reverse">
            <button className=" mx-3 bg-[#80FF00] hover:bg-blue-300 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-l-full rounded-r-full text-lg px-4 py-2 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
              ĐĂNG KÝ
            </button>
            <button
              type="button"
              onClick={() =>
                (window.location.href = "https://www.766766766.com/register")
              }
              className="text-[#2B8DFE] bg-white border-2 border-[#2B8DFE] hover:bg-blue-300 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-l-full rounded-r-full text-lg px-4 py-2 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
            >
              ĐĂNG NHẬP
            </button>
            {/* Nút hamburger mở/đóng menu */}
            <button
              onClick={toggleMenu} // Gọi hàm toggleMenu khi nhấn nút
              type="button"
              className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
              aria-controls="navbar-sticky"
              aria-expanded={isMenuOpen ? "true" : "false"} // Cập nhật aria-expanded
            >
              <span className="sr-only">Open main menu</span>
              <svg
                className="w-5 h-5"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 17 14"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M1 1h15M1 7h15M1 13h15"
                />
              </svg>
            </button>
          </div>
          {/* Menu */}
          
        </div>
      </nav>

      {/* Mobile */}
      <nav className="bg-[#2B8DFE] h-[70px] border-gray-200 dark:bg-gray-900 block md:hidden fixed top-0 left-0 right-0 z-50">
        <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4">
          <div className="flex items-center">
            <button
              data-collapse-toggle="navbar-default"
              onClick={toggleMenu}
              type="button"
              className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-white rounded-lg hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
              aria-controls="navbar-default"
              aria-expanded={isMenuOpen ? "true" : "false"}
            >
              <span className="sr-only">Open main menu</span>
              <svg
                className="w-5 h-5"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 17 14"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeidth="2"
                  d="M1 1h15M1 7h15M1 13h15"
                />
              </svg>
            </button>
            <a
              href="https://www.rr88bet.com/"
              className="flex items-center space-x-3 rtl:space-x-reverse"
            >
              <img src={logo} alt="RR88 Logo" />
            </a>
          </div>
          <div className="text-[0.7rem]">
            <button
              type="button"
              onClick={() =>
                (window.location.href = "https://www.766766766.com/register")
              }
              className="text-[#2B8DFE] bg-white border-2 border-[#2B8DFE] hover:bg-blue-300 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-l-full rounded-r-full p-1 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
            >
              ĐĂNG NHẬP
            </button>
            <button className=" bg-[#80FF00] hover:bg-blue-300 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-l-full rounded-r-full p-1 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
              ĐĂNG KÝ
            </button>
          </div>

          <div
            className={`items-center  justify-between w-full ${
              isMenuOpen
                ? "block fixed inset-0 bg-black/30 backdrop-blur-sm z-40 transition-opacity"
                : "hidden"
            }`}
            onClick={() => setIsMenuOpen(false)}
            id="navbar-sticky"
          >
            <div className="w-[250px] ">
              <ul className="text-[#2B8DFE] gap-3 font-medium h-screen flex flex-col p-4 md:p-0 mt-4 border border-gray-100 rounded-lg bg-gray-50 md:flex-row md:space-x-8 rtl:space-x-reverse md:mt-0 md:border-0 md:bg-white dark:bg-gray-800 md:dark:bg-gray-900 dark:border-gray-700">
                <img src={logoNavMobile} alt="photo" />

                <li>
                  <a
                    href="https://www.766766766.com/"
                    className="block py-2 px-3 border-b border-[#2B8DFE]   hover:bg-gray-100 md:hover:bg-transparent  md:hover:text-blue-700 md:p-0 dark:text-white md:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent"
                    aria-current="page"
                  >
                    TRANG CHỦ
                  </a>
                </li>
                  <li>
                  <a
                    href="https://www.766766766.com/"
                    className="block py-2 px-3 border-b border-[#2B8DFE]   hover:bg-gray-100 md:hover:bg-transparent  md:hover:text-blue-700 md:p-0 dark:text-white md:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent"
                    aria-current="page"
                  >
                   ĐẶC QUYỀN VIP
                  </a>
                </li>
                <li>
                  <a
                    href="https://dailyrr88.com/"
                    className="block py-2 px-3 border-b border-[#2B8DFE]   rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-white md:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent"
                  >
                    ĐẠI LÝ
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.766766766.com/promotions"
                    className="block py-2 px-3 border-b border-[#2B8DFE]   rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-white md:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent"
                  >
                    KHUYẾN MÃI
                  </a>
                </li>
                <li>
                  <a
                    href="https://cskhrr88.com/"
                    className="block py-2 px-3 border-b border-[#2B8DFE]   rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-white md:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent"
                  >
                    CSKH 24/7
                  </a>
                </li>
                <button
                  className="bg-[#019DFA] text-white w-[13rem] rounded-xl h-[3rem] mx-auto"
                  onClick={() =>
                    (window.location.href =
                      "https://www.766766766.com/register")
                  }
                >
                  Đăng Nhập
                </button>
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Header;
